<template>
  <div v-if="$attrs.isLoading">
    <v-row class="mr-n1">
      <v-col :class="cssClass.url" cols="10">
        <v-skeleton-loader height="38px" type="image"> </v-skeleton-loader>
      </v-col>
      <v-col cols="1" class="px-1">
        <v-skeleton-loader type="button"> </v-skeleton-loader>
      </v-col>
      <v-col cols="1" class="px-1">
        <v-skeleton-loader type="button"> </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
  <div :class="cssClass.wrapper" v-else>
    <v-row v-if="!(irisMimic || getIrisRdonlyMode)" align-content="center" class="d-flex justify-center">
      <v-col :class="cssClass.url" :cols="$attrs.irisPurple != '' && !$slots['edn-append-outer'] ? '10' : '12'">
        <edn-field
          :placeholder="getPlaceholder"
          @requiredChange="fillRules()"
          id="urlToCopy"
          :invalidMsg="invalidMsg"
          :prepend-inner-icon="getPrependInnerIcon"
          v-model="Value"
          v-bind="$attrs"
          v-on="$listeners"
          :pattern="pattern"
          :error="!getUrlValidity"
          @update:error="isReady($event)"
          :clearable="!$attrs.readonly === ''"
          :outlined="$attrs.readonly === ''"
          :class="[$attrs.readonly === '' ? 'text--disabled' : '', getIrisCssClass,cssClass.input]"
          @blur="errorTest();checkUrlRoot()"
        >
          <template v-slot:append v-if="$attrs.tooltip">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" style="cursor: pointer">mdi-help-circle-outline</v-icon>
              </template>
              {{ $attrs.tooltip }}
            </v-tooltip>
          </template>
          <template v-slot:edn-append-outer><slot name="edn-append-outer"></slot></template>
        </edn-field>
        <edn-field style="position:fixed;opacity:0" v-model="getPrefixedUrl" ref="prefixedInput"></edn-field>
      </v-col>
      <v-col
        v-if="$attrs.irisPurple != '' && !$slots['edn-append-outer']"
        cols="1"
        :align-self="$attrs.readonly == '' ? 'start' : 'center'"
        :class="['text-center', $attrs.readonly == '' ? 'mt-4' : '',cssClass.url]"
      >
        <v-tooltip v-model="copied" top>
          <template v-slot:activator="{ on }">
            <v-btn :on="on" icon :disabled="!valid || Value == ''"  :class="getBtnCssClass" @click="copy()">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span> {{ pasteContentRes }}</span>
        </v-tooltip>
      </v-col>
      <v-col
        v-if="$attrs.irisPurple != '' && !$slots['edn-append-outer']"
        cols="1"
        :align-self="$attrs.readonly == '' ? 'start' : 'center'"
        :class="['text-center', $attrs.readonly == '' ? 'mt-4' : '',cssClass.url]"
      >
        <v-btn icon :disabled="!valid || Value == ''"  :class="getBtnCssClass" @click="goto()">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <edn-mimic
      :rules="rules"
      :class="getIrisCssClass"
      v-bind="$attrs"
      :pattern="pattern"
      v-model="Value"
      type="url"
      v-else
    />
  </div>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednRegex } from './mixins/ednRegex'
import ednMimic from './ednMimic'
import { ednMimicMix } from './mixins/ednMimicMix'
import { ednSocialIcon } from './mixins/ednSocialIcon'

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednMimicMix, ednRegex,ednSocialIcon],
  components: {
    ednMimic,
  },
  computed: {
    /**
     * Récupère l'icône qu'il faut afficher à gauche du champs 
     * Soit affiche l'icône renseigné (socialIcon) 
     * Soit on affiche l'icône qui correspond au préfixe renseigné
     */
    getPrependInnerIcon() {
      if (this.$attrs.irisPurple === '') return ''
      else if(this.getSocialIcon && this.getSocialIcon != undefined && this.isUrlPrefixed) 
        return this.getSocialIcon;
      else if (this.valid) {
        return 'mdi-earth'
      } else {
        return 'mdi-earth-off'
      }
    },
    pasteContentRes() {
      return this.$attrs.pasteContentRes || this.$vuetify.lang.t('$vuetify.pasteContentRes');
    },
    /** On vérifie que le préfixe est bien renseigné */
    isUrlPrefixed(){
      return this.prefix != '' && this.prefix != null && this.prefix != undefined;
    },
    /**
     * On construit l'url avec le préfixe si renseigné
     */
    getPrefixedUrl:{
      get(){
        return this.isUrlPrefixed ? this.prefix + this.value : this.value;
      },
      set(value){
        this.$emit('update:value',value);
      }
    },
    /**
     * Soit on affiche la racine de l'url (préfixe) renseignée.
     * Soit on affiche le placeholder renseigné par l'utilisateur.
     */
    getPlaceholder(){
      //Extract this nested ternary operation into an independent statement
      if (this.$attrs.placeholder) {
        return this.$attrs.placeholder;
      }
      return this.getPrefixedUrl ? this.prefix : '';
    },
    /**
     * Retourne les classes css des boutons copier et goto
     */
    getBtnCssClass(){
      return this.cssClass.button || 'pb-2'
    },
    Value: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.checkUrlValidity();
      }
    },
    getUrlValidity() {
      this.checkUrlValidity();
      return this.valid;
    }
  },
  props: {
    irisMimic: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => '',
    },
    pattern: {
      type: RegExp,
      default: () =>
        //$|^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/,
    },
    // permet de renseigner un préfixe et ainsi de n'afficher que la valeur
    prefix:{
      type:String,
      default:()=> ''
    },
    // Permet d'afficher un icône personnalisé à gauche du champs 
    socialIcon:{
      type:String,
      default:()=> null
    },
    //classes css provenant du parent
    cssClass: {
      type: Object,
      default: () => { return {input:'',button:'pb-2',url:''}},
    },
  },
  data() {
    return {
      valid: null,
      copied: false,
    }
  },
  mounted() {
    this.checkUrlValidity();
  },
  watch: {
    /** Si le mode d'affichage change (avec ou sans préfixe), on relance les règles afin de changer le validateur de format */
    isUrlPrefixed(){
      this.checkUrlValidity();
      this.fillRules();
    },
    /** vérifie la validité de l'url complète si le préfixe change */
    prefix(){
      this.checkUrlValidity();
    }
  },
  methods: {
    copy() {
      let contentUrl;
      if(!this.isUrlPrefixed)
        contentUrl = this.$el.querySelector('input');    
      else
        contentUrl = this.$refs.prefixedInput.$el.querySelector('input');

      contentUrl.select()
      document.execCommand('copy')
      contentUrl.blur()
      this.copied = true

      setTimeout(() => {
        this.copied = false
      }, 3000)
    },
    goto() {
      let content = !this.isUrlPrefixed ? this.Value : this.getPrefixedUrl
      if (!this.isUrlPrefixed && !/(http:\/\/|https:\/\/)/.test(content)) {
        content = 'http://' + content;
        this.Value = content;
      }

      window.open(content, '_blank')
    },
    errorTest() {
      this.$emit('onError', this.pattern.test(this.Value));
    },
    /**
     * On vérifie que le format est valide
     */
    checkUrlValidity(){
      if(!this.isUrlPrefixed) this.valid = this.pattern.test(this.Value) 
      else this.valid = this.pattern.test(this.getPrefixedUrl)  || this.pattern.test(this.Value)
    },
    /** Si l'utilisateur colle ou écrit une url avec la même racine que le préfixe renseigné, 
     * on n'affiche que la valeur au blur 
     * */
    checkUrlRoot(){
      if(this.isUrlPrefixed && this.Value.includes(this.prefix))
        this.Value = this.Value.replace(this.prefix,'')
    }
  },
}
</script>
<style lang="scss">
div {
  &.v-input--is-readonly {
    pointer-events: none;
    user-select: none;
  }
}
</style>
